"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function ProgressBar({ backgroundColor, borderColor, fillColor, progress, style, ...props }) {
    const percentage = Math.max(0, Math.min(1, Number.isFinite(progress) ? progress : 0)) * 100;
    return ((0, jsx_runtime_1.jsx)("div", { ...props, role: "progressbar", "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": percentage, style: {
            backgroundColor,
            border: `1px solid ${borderColor}`,
            boxSizing: "border-box",
            height: "1rem",
            overflow: "hidden",
            width: "100%",
            ...style,
        }, children: (0, jsx_runtime_1.jsx)("div", { style: {
                backgroundColor: fillColor,
                height: "100%",
                width: `${percentage}%`,
            } }) }));
}
exports.ProgressBar = ProgressBar;
